import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import './index.css';
// Adresteki chunk-yenileme işaretini router oluşmadan temizler (bkz. chunkLoad.ts).
import './lib/chunkLoad';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
